var exports = {
  "lm": "LanguageTab.module__notice___U2phN0",
  "ut": "LanguageTab.module__noticeText___U2phN0",
  "nf": "LanguageTab.module__link___U2phN0",
  "XG": "LanguageTab.module__languageSelect___U2phN0",
  "pK": "LanguageTab.module__languageControls___U2phN0",
  "e5": "LanguageTab.module__timeControls___U2phN0",
  "_9": "LanguageTab.module__languageOption___U2phN0",
  "Ri": "LanguageTab.module__languageOptionMenu___U2phN0",
  "l5": "LanguageTab.module__languageDetails___U2phN0",
  "aX": "LanguageTab.module__languageCode___U2phN0",
  "Eb": "LanguageTab.module__flagImage___U2phN0",
  "TU": "LanguageTab.module__flagImageText___U2phN0",
  "hx": "LanguageTab.module__languageOptionCompact___U2phN0",
  "cL": "LanguageTab.module__languageName___U2phN0",
  "X6": "LanguageTab.module__languageOptionSelected___U2phN0",
  "rv": "LanguageTab.module__tooltipContent___U2phN0",
  "HE": "LanguageTab.module__tooltipText___U2phN0",
  "QT": "LanguageTab.module__switchWrapper___U2phN0",
  "Kx": "LanguageTab.module__spellcheckHint___U2phN0",
  "OO": "LanguageTab.module__spellcheckRestartBanner___U2phN0",
  "Ru": "LanguageTab.module__dictionaryGrid___U2phN0",
  "b": "LanguageTab.module__dictionaryRow___U2phN0",
  "CG": "LanguageTab.module__dictionaryRowChecked___U2phN0",
  "mj": "LanguageTab.module__dictionaryName___U2phN0",
  "P": "LanguageTab.module__dictionaryTag___U2phN0",
  "Wc": "LanguageTab.module__manualDictionaryBlock___U2phN0",
  "uW": "LanguageTab.module__personalDictAddRow___U2phN0",
  "bU": "LanguageTab.module__personalDictInput___U2phN0",
  "rj": "LanguageTab.module__personalDictList___U2phN0",
  "ze": "LanguageTab.module__personalDictChip___U2phN0",
  "nm": "LanguageTab.module__personalDictChipRemove___U2phN0",
  "ib": "LanguageTab.module__personalDictEmpty___U2phN0",
};

module.exports = exports;
